class ScrollToReviews extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleClick = this.handleClick.bind(this)

    this.listeners.add(this, 'click', this.handleClick)
  }

  handleClick (event) {
    event.preventDefault()

    const reviews = this.externalEls.reviews.element

    if (reviews) {
      const rootStyles = getComputedStyle(document.documentElement)
      const offset =
        (parseInt(rootStyles.getPropertyValue('--Header_Banner'), 10) || 100) +
        20
      const reviewsPosition =
        reviews.getBoundingClientRect().top + window.pageYOffset - offset
      window.scrollTo({ top: reviewsPosition, behavior: 'smooth' })
    }
  }
}

if (!customElements.get('scroll-to-reviews')) {
  customElements.define('scroll-to-reviews', ScrollToReviews)
}
